import React, {useEffect, useState,Component} from 'react'
import {Route, Redirect} from 'react-router-dom'
import userService from '../services/userapi'
import { getAccessToken, setAccessToken } from '../services/accessToken'
import jwtDecode from 'jwt-decode'
import { useSelector, useDispatch } from 'react-redux'


const PrivateRoute = ({component: Component, ...rest}) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null)
    let data = JSON.parse(sessionStorage.getItem('user'))
    const refreshTheToken = async () => {
        //console.log("Refreshing the token")
        return userService.regenerateToken().then(x => {
          //console.log("FOUND REFRESH Private")
          const {accessToken} = x
          return accessToken
        })
    }

    const hasAccess = async (access) => {
        if(access === undefined){
          //generate token
          access = await refreshTheToken()
          return access
        }
    
        return access
      }

    useEffect(() => {
        async function checkAuthorization() {
            let token = getAccessToken()
            // console.log("The token for priv", token)
            // console.log("The user for priv", data)
                if(token && (data != undefined)){
                    let {exp} = jwtDecode(token)
                    let dateNow = new Date();
                    //console.log(exp)
                    //console.log(dateNow.getTime()/1000)
                    if(exp < dateNow.getTime()/1000) {
                        console.log("Access token has expired")
                        // const accessT = refreshTheToken().then(theA => {
                        //     return theA
                        // })
                        try{
                            const accessT = await refreshTheToken()
                            //console.log("from private route", accessT)
                            if (accessT) {
                                //console.log("retried to fetch refresh token successfully", accessT)
                                setAccessToken(accessT)
                                setIsAuthenticated(true)
                            }else{
                                setIsAuthenticated(false)
                            }
                        }catch(err){
                            console.error("problem with refresh token, sign in again ")
                            setIsAuthenticated(false)
                        }
                       
                    }else{
                        setIsAuthenticated(true)
                    }
                }else if(token == "" && data){
                    console.log("token is empty and user is not")
                    const accessT = await refreshTheToken()
                    if (accessT) {
                        setAccessToken(accessT)
                        setIsAuthenticated(true)
                    }else{
                        setIsAuthenticated(false)
                    }
                }
                else{
                    console.log("in the false place")
                    setIsAuthenticated(false)
                }
        }

        checkAuthorization()
    },[])

    if(isAuthenticated === null){
        return<></>
    }

    return (
        <Route {...rest} render={props =>
            !isAuthenticated ? (
              <Redirect to='/login'/>
            ) : (
              <Component {...props} />
            )
          }
        />
    )
}

export default PrivateRoute